"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gridDefaultProps = exports.GRID_SPACING_CSS_VARIABLE_NAME = exports.GRID_SPACING = exports.GRID_ITEM_CLASS_NAME = exports.GRID_COLUMNS = void 0;
const GRID_COLUMNS = exports.GRID_COLUMNS = {
  lg: 12,
  md: 8,
  sm: 4
};
const GRID_SPACING = exports.GRID_SPACING = {
  xl: 32,
  lg: 32,
  md: 24,
  sm: 16
};
const GRID_ITEM_CLASS_NAME = exports.GRID_ITEM_CLASS_NAME = 'stencil-grid-item';
const GRID_SPACING_CSS_VARIABLE_NAME = exports.GRID_SPACING_CSS_VARIABLE_NAME = '--stencil-grid-spacing';
const gridDefaultProps = exports.gridDefaultProps = {
  ...GRID_COLUMNS
};